import { jsx } from 'react/jsx-runtime';
import { LoadingOverlay } from '@mantine/core';
import useStyles from './WarzonePanelLoader.styles.js';
var WarzonePanelLoader = function WarzonePanelLoader(_ref) {
  var backgroundColor = _ref.backgroundColor,
    classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled;
  var _useStyles = useStyles(void 0, {
      name: "WarzonePanelLoader",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes;
  return /* @__PURE__ */jsx("div", {
    className: classes.root,
    children: /* @__PURE__ */jsx(LoadingOverlay, {
      visible: true,
      overlayBlur: 2,
      overlayColor: backgroundColor
    })
  });
};
export { WarzonePanelLoader };